module.exports = __webpack_public_path__ + "img/dashboard_alert_image@2x.439404c.png";